export var HABIT_STORAGE_KEY = location
    ? "CNUI_HABIT_".concat(location.origin).concat(location.pathname)
    : 'CNUI_HABIT';
